export default __webpack_public_path__ + "static/media/style.3488d259.css";